export default "\r\n<app-service-list></app-service-list>\r\n\r\n\r\n";